module.exports = __webpack_public_path__ + "static/media/action-b.33b73ece.jpg";